export const onboardingContext = Object.seal({
  createGrade: [],
  hasClasses: false,
  workspacesWrapper: null,
  workspaceEssaygrader: null,
});
